import { twMerge } from 'tailwind-merge';

import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

type TabsSkeletonProps = {
  className?: string;
};

export default function TabsSkeleton(props: TabsSkeletonProps) {
  const { className } = props;

  return (
    <div className={twMerge('flex items-center justify-between animate-pulse', className)}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex flex-col items-center gap-[8px]">
          <SkeletonBlock className="size-[24px]" />
          <SkeletonBlock className="w-[50px] h-[16px]" />
        </div>
      ))}
    </div>
  );
}
